import React from 'react';
import {useHistory} from 'react-router'
import {makeStyles, Container, Paper, Grid, Dialog, AppBar, Toolbar, Slide, IconButton} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import ApproveLeaveForm from '../../LeaveApplication/component/Form'
import Balance from '../../LeaveApplication/component/Balance'
import RecentLeave from '../../LeaveApplication/component/RecentLeave'
import RecentLeaveCollection from '../../Function/RecentLeaveCollection'
import customAxios from "../../../components/API/customAxios";
import Details from "../../../components/MyLeave/component/Details"
import {useIntl} from 'react-intl';
import {checkUndefined} from "../../Function/globalFunction";
import MiniTable from "../../UIComponent/MiniTable";
import CompLeaveCollection from "../../Function/CompLeaveCollection";

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: '#232F3E',
    },
    modal: {
        display: 'flex',
        padding: theme.spacing(1),
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalPaper: {
        backgroundColor: '#f0f2f5',
        borderRadius: '5px',
        boxShadow: theme.shadows[5],
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    mainPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
    },
    subPaper: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Approve({approveMode, handleClose, open, showId, isNewCompLeave, tabIndex, source}) {
    const mode = window.global.approveMode
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [application, setApplication] = React.useState({});
    const [showDetail, setShowDetail] = React.useState(false);
    const [rows, setRows] = React.useState([]);
    const [compLeaveRows, setCompLeaveRows] = React.useState([]);
    const [employeeDuty, setEmployeeDuty] = React.useState('');
    if (source) {
        isNewCompLeave = source == 'newCompLeave';
    }
    const path = isNewCompLeave ? '/get_comp_leave_req/' : '/get_approve/';
    const page = isNewCompLeave ? 'Approve Comp Leave' : 'Approve Leave';

    React.useEffect(() => {
        customAxios.get(path + showId)
            .then(res => {
                if (String(res.data.status) !== window.global.withdrawn) {
                    setShowDetail(true);
                } else {
                    setShowDetail(false);
                }

                setApplication(res.data);
                setRows(RecentLeaveCollection(res.data['recent_leave'], intl));
                setCompLeaveRows(CompLeaveCollection(res.data['comp_leave_balance'], intl));
                setShowCompetent(true);
                setEmployeeDuty(res.data['staff_duty'])
            }, error => {
                history.push('/home');
            });
    }, []);

    return (
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}
                PaperProps={{
                    style: {
                        backgroundColor: '#f0f2f5',
                        boxShadow: 'none',
                    },
                }}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Container maxWidth="lg" className={classes.container}>
                {showCompetent ?
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={7}>
                            <Paper className={classes.mainPaper}>
                                <ApproveLeaveForm
                                    mode={mode}
                                    employeeId={application.employee.id}
                                    employeeName={application.employee.employee_name}
                                    staffDuty={application.employee.staff_duty}
                                    annualAllowances={application.employee.annual_allowances}
                                    annualTotal={application.employee.annual_total}
                                    editTypeId={application.type_id}
                                    editTypeName={intl.formatMessage({id: 'guideline.' + application.type.name})}
                                    editStartDate={application.start_date}
                                    editStartTime={application.start_time}
                                    editUntilDate={application.until_date}
                                    editEndTime={application.end_time}
                                    editPeriod={application.period}
                                    editReason={checkUndefined(application.reason)}
                                    editAttachment={application.attachment}
                                    editAttachmentPath={checkUndefined(application.attachment_path)}
                                    editStatus={application.status}
                                    editUpdatedAt={application.updated_at}
                                    approveMode={approveMode}
                                    approveId={showId}
                                    isNewCompLeave={isNewCompLeave}
                                    compLeaveRows={compLeaveRows}
                                    tabIndex={tabIndex}
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={12} lg={5}>
                            <Paper className={classes.subPaper}>
                                <Balance
                                    mode={mode}
                                    userRole={application.user_role}
                                    annualAllowances={application.employee.annual_allowances}
                                    sickAllowances={application.employee.sick_allowances}
                                />
                            </Paper>
                            {employeeDuty === 'OFFICE HOURS' ? (
                                <Paper className={classes.subPaper}>
                                    <MiniTable rows={compLeaveRows} staffDuty={application?.staff_duty} />
                                </Paper>
                            ) : ''}
                            {showDetail &&
                                <Paper className={classes.subPaper}>
                                    <Details 
                                        handleClose={null} 
                                        open={null} 
                                        showId={application.id} 
                                        page={page}
                                    />
                                </Paper>
                            }
                            <Paper className={classes.subPaper}>
                                <RecentLeave rows={rows}/>
                            </Paper>
                        </Grid>
                    </Grid>
                    :
                    <div className={classes.circularProgress}>
                        <CircularProgress/>
                    </div>
                }
            </Container>
        </Dialog>
    )
}
